<template>
    <div>
        <div class="flex items-center justify-between">
            <form-label name="Outline" />
            <font-awesome-icon icon="fa-solid fa-compress" class="cursor-pointer text-gray-400 hover:text-white"
                title="Collapse all" @click="collapseAll(treeData)" />
        </div>
        <!-- <form-checkbox class="m-3" label="preview icons" v-model="preview_icon" /> -->

        <div class="mt-3 hide-scrollbar overflow-y-scroll">
            <tree :tree_data="treeData" :preview_icon="preview_icon" />
        </div>
    </div>
</template>

<script>
import HaspObject from '../Hasp/HaspObject';
import HaspPage from '../Hasp/HaspPage';
import PageOverlay from '../draw/PageOverlay';
import tree from './Treeview.vue';
import { useCanvasModeStore } from '../stores/canvasModeStore.js';

export default {
    name: 'layertreeview',
    components: {
        tree,
    },
    props: {
        objectlayer: {
            required: true,
        },
        treekey: {
            required: true,
        },
        settings: {
            type: Object,
            default: () => ({}),
        },
    },
    emits: ['node-select'],
    provide() {
        return {
            openHassBuilder:  this.openHassBuilder,
            selectNode:       this.selectNodeFromTree,
        };
    },
    data: () => {
        return {
            treeData: [],
            preview_icon: true,
        };
    },
    mounted() {
        this.treeData = this.getChildren(this.objectlayer);
    },
    watch: {
        treekey: function () {
            this.treeData = this.getChildren(this.objectlayer);
        },
    },
    methods: {
        /** The house icon: show the object's Home Assistant flows (HA mode) with the object selected. */
        openHassBuilder(node) {
            useCanvasModeStore().setMode('hass');
            this.selectNodeFromTree(node);
        },
        selectNodeFromTree(node) {
            if (node.obj === 'Page0 Overlay') return;
            const layer = node.getLayer?.();
            if (!layer) return;
            if (layer.isTemplateContextNode?.(node)) return;
            layer.setSelectedNode(node);
            // Only scroll canvas to the object for explicit tree clicks,
            // not for programmatic selections from history navigation.
            if (!node.isType?.('page') && !node.isType?.('template_page')) {
                layer.moveIntoView();
            }
            this.$emit('node-select', node);
        },
        collapseAll(nodes) {
            if (!nodes) return;
            nodes.forEach(node => {
                node.hasp_obj.expanded = false;
                if (node.children) this.collapseAll(node.children);
            });
        },
        getChildren(container) {
            if (!container) return;
            const children = [];
            // Sort children by haspid to make the treeview more predictable
            const sortedChildren = container.children.slice().sort((a, b) => {
                if (a.haspid === undefined) return 1;
                if (b.haspid === undefined) return -1;
                return a.haspid - b.haspid;
            });
            sortedChildren.forEach((child, index) => {
                if (child instanceof PageOverlay) {
                    children.push({
                        id: child._id,
                        index: index,
                        hasp_id: '',
                        name: child.obj,
                        comment: '',
                        hasp_obj: child,
                        expanded: false,
                    });
                }
                if (child instanceof HaspObject) {
                    if (child.isContainer()) {
                        let comment = child.comment;
                        if(child.isType('tab')){
                            comment =  child.text + '  ' + child.comment;
                        }
                        children.push({
                            id: child._id,
                            index: index,
                            hasp_id: child.haspid,
                            name: child.obj,
                            comment: comment,
                            children: this.getChildren(child),
                            hasp_obj: child,
                            expanded: false,
                        });
                    } else {
                        let comment = child.comment || '';
                        if (child.isType('mtrx_btn')) {
                            comment = child.text + ' pos:' + child.row_col.row + ',' + child.row_col.col;
                        } 
                        children.push({
                            id: child._id,
                            index: index,
                            hasp_id: child.haspid,
                            name: child.obj,
                            comment: comment,
                            hasp_obj: child,
                            expanded: false,
                        });
                       
                    }
                }
            });
            return children;
        },
    },
};
</script>
